// extracted by mini-css-extract-plugin
export default {"itemLocked":"CertificateItem_itemLocked__uNY6B"};